import styled from 'styled-components'

export const EditSectionHeader = styled.div`
  margin: 0 auto;
  max-width: 840px;
`

export const SaveOrderContainer = styled.div`
  display: flex;
  column-gap: 10px;
  align-items: baseline;
`
